import './QuizzesList.css'
import TableHead from "../../../components/utilities/table/TableHead";
import PageLayout from "../../../layout/page-layout/PageLayout";
import {IFRAME_DOMAIN} from "../../../utilities/Constants";
import Table from "../../../components/utilities/table/Table";
import TableBody from "../../../components/utilities/table/TableBody";
import {useContext, useEffect, useMemo, useState} from "react";
import TableRow from "../../../components/utilities/table/TableRow";
import {Button} from "react-bootstrap";
import FlexBox from "../../../components/utilities/FlexBox";

import SearchBar from "../../../components/search/SearchBar";
import axios from "axios";
import Loader from "../../../components/utilities/Loader";
import {API_URL_PREFIX, APP_URL_PREFIX, PASS_THRESHOLD, TEST_REVIEW_PRIVILEGE} from "../../../utilities/Constants";
import {
    CustomErrorToast,
    CustomLoadingToast,
    CustomToastContainer,
    updateCustomErrorToast,
    updateCustomSuccessToast
} from "../../../components/utilities/CustomToast";
import {CameraFill, Images, PcDisplayHorizontal, PersonFill, WebcamFill, X} from "react-bootstrap-icons";
import ConfirmModal from "../../../components/utilities/ConfirmModal";
import Utilities from "../../user/login-register/Utilities";
import Status from "../../../components/quiz-result/Status";
import CompanyTeamContext from "../../../CompanyTeamContext";
import RadioOptions from "../../../components/utilities/radio-options/RadioOptions";
import {Link, useNavigate, useParams} from "react-router-dom";
import Tooltip from "../../../components/utilities/Tooltip";
import {resendTest} from "../../candidate/candidate-utils/CandidateUtils";
import ModalBackground from "../../../components/utilities/modal/ModalBackground";
import {getTestName, isLiveTestOrQuiz} from "../../test/tests-list/TestsList";
import { ReactComponent as TestChartsIcon } from '../../../assets/candidate-profile/TestChartsIcon.svg';
import { ReactComponent as RestoreTestIcon } from '../../../assets/candidate-profile/RestoreTestIcon.svg';
import { ReactComponent as ScreenshotsIcon } from '../../../assets/candidate-profile/ScreenshotsIcon.svg';
import { ReactComponent as ResendResultsIcon } from '../../../assets/candidate-profile/ResendResultsIcon.svg';
import { ReactComponent as DeleteTestIcon } from '../../../assets/candidate-profile/DeleteIconBig.svg';
import { ReactComponent as TestResultsIcon } from '../../../assets/candidate-profile/TestResultsIcon.svg';
import { ReactComponent as ProfilePicturesIcon } from '../../../assets/candidate-profile/ProfilePicturesIcon.svg';
import DisqualifiedIcon from '../../../assets/candidate-profile/DisqualifiedIcon.svg';
import GradeMobileIcon from "../../../assets/dashboard/gradeMobile.svg";
import DateMobileIcon from "../../../assets/dashboard/dataMobile.svg";
import ReactTooltip from 'react-tooltip';
import ViewProfilePicturesIcon from '../../../assets/tests-list/viewProfilePictures.svg';
import ViewScreenShotsIcon from '../../../assets/tests-list/viewScreenShots.svg';
import ResendTestIcon from '../../../assets/tests-list/resendTest.svg';
import TestResultsIconMobile from '../../../assets/tests-list/testResults.svg';
import TestChartsIconMobile from '../../../assets/tests-list/testCharts.svg';
import DeleteTestIconMobile from '../../../assets/tests-list/deleteTest.svg';
import RestoreTestIconMobile from '../../../assets/tests-list/RestoreTestIcon.svg';
import ConfirmModalDeleteIcon from '../../../assets/tests-list/confirmModalDeleteIcon.svg';
import DsqMobileIcon from '../../../assets/tests-list/dsqMobileIcon.svg';
import testReportIcon from '../../../assets/candidate-profile/testReport.svg';




const QuizzesList = () => {
    const [quizzes, setQuizzes] = useState([])
    const [loader, setLoader] = useState(true)
    const [keyword, setKeyword] = useState("")
    const [state, setState] = useState("all")
    const {filter} = useParams()
    const [showIframe, setShowIframe] = useState(false)
    const [iframeSrc, setIframeSrc] = useState("")
    const company = useContext(CompanyTeamContext)
    const navigate = useNavigate();


    useEffect(()=>{
        setState(filter || "all")
    },[filter])


    useEffect(()=>{
        if(company){
            document.title  = "Tests Status - " + company.basicTitle
            return () => {
                document.title = company.basicTitle
            }
        }
    },[company])

    // Hide tooltips on scroll and touch for mobile
    useEffect(() => {
        const hideTooltip = () => {
            ReactTooltip.hide();
        };

        window.addEventListener('scroll', hideTooltip, true);
        window.addEventListener('touchstart', hideTooltip);
        window.addEventListener('touchmove', hideTooltip);

        return () => {
            window.removeEventListener('scroll', hideTooltip, true);
            window.removeEventListener('touchstart', hideTooltip);
            window.removeEventListener('touchmove', hideTooltip);
        };
    }, [])

    useEffect(() => {
        axios.get(API_URL_PREFIX+"/GetCompanyLiteQuizzes.html")
            .then(response => {
                setLoader(false)
                if (response.data.err) {
                    CustomErrorToast("Permission Denied!")
                } else {
                    setQuizzes(response.data)
                    // Rebuild tooltips after content loads
                    setTimeout(() => ReactTooltip.rebuild(), 100);
                }
            })
            .catch(e => {
                setLoader(false);
                if (e.response.status == 403) {
                    CustomErrorToast("Permission Denied!")
                } else {
                    CustomErrorToast("Error fetching tests, Please try again.")
                }

            })
    }, [])

    const getFilteredList = ()=>{
        let filteredByKeyword = quizzes?.filter(t => {
            return t.testName.toLowerCase().includes(keyword.toLowerCase()) || t.candidateName.toLowerCase().includes(keyword.toLowerCase())
        });
        let filteredByType;
        switch (state){
            case "all":
                filteredByType = filteredByKeyword;
                break;
            case "expired":
                filteredByType = filteredByKeyword.filter(e=>(e.isExpired && e.quizScore == 0));
                break;
            case "pending":
                filteredByType = filteredByKeyword.filter(e=> !e.isExpired && (!e.quizScore && e.quizScore != 0));
                break;
            case "completed":
                filteredByType = filteredByKeyword.filter(e=>(e.quizScore || e.quizScore == 0));
                break;
        }
        return filteredByType;
    }

    const filteredList = useMemo(getFilteredList,[quizzes, filter, keyword, state])

    // Rebuild tooltips when filtered list changes
    useEffect(() => {
        setTimeout(() => ReactTooltip.rebuild(), 100);
    }, [filteredList]);

    return (<PageLayout height={"100%"} pageClassName="quizzes-list-page-wrapper" >
        <CustomToastContainer />
        {showIframe && <IframeModal setShow={setShowIframe} src={iframeSrc} />}
        <Loader loader={loader}/>
        <div className="quizzes-list-page" style={{justifyContent: "top", display: "flex",height:"100%", width: "100%", flexDirection: "column", padding: "30px"}}>

            {/* Desktop Layout */}
            <div className="quizzes-desktop">
                <FlexBox style={{width: "100%"}} justify={"space-between"}>
                    <h3 style={{color: "#364454", fontWeight: "700", fontSize: "20px"}}>Tests Results</h3>
                    <SearchBar justify={"end"} value={keyword} setValue={e => setKeyword(e.target.value)}
                               placeHolder={"Search by Test or Candidate Name"}/>
                    <RadioOptions color={"#000"} value={state}
                        setValue={(value) => {
                            setState(value);
                            navigate(`/quiz/list/${value === 'all' ? '' : value}`);
                            }}
                            options={[{name:"All", value:"all"},{name:"Completed", value:"completed"},{name:"Pending", value:"pending"},{name:"Expired", value:"expired"}]}/>
                </FlexBox>
                <br/>
                <div className={"table-wrapper"}>
                    <Table id={"quizzesTable"}>
                        <TableHead columns={["", "Assigned to", "Test Name", "Last Modified",
                            <FlexBox justify={"start"} style={{height:"100%"}}>Score&nbsp;<Tooltip text={"Score out of 100"} /></FlexBox>,
                            <FlexBox justify={"start"} style={{height:"100%"}}>Status&nbsp;<Tooltip text={"Pass score set at 60%"} /></FlexBox>,"Supervised", "Actions"]}/>
                        <TableBody>
                            {!loader && (!filteredList || filteredList.length == 0)
                                && <tr>
                                    <td style={{verticalAlign: "middle", color: "#bababa", textAlign: "center"}} rowSpan={5}
                                        colSpan={6}>No Tests Found.
                                    </td>
                                </tr>}
                            {filteredList && filteredList.map((quiz, i) => {
                                return (<QuizRow setShowIframe={setShowIframe} setIframeSrc={setIframeSrc} setQuizzes={setQuizzes} i={i} quiz={quiz}/>)
                            })}
                        </TableBody>
                    </Table>

                </div>
                <div style={{marginTop:"10px", fontSize:"12px", textAlign:"left"}}>{!filteredList ? 0 : filteredList.length} Tests</div>
            </div>

            {/* Mobile Layout */}
            <FlexBox className="quizzes-mobile" style={{display: "none", flexDirection: "column", width: "100%"}}>
                <ReactTooltip className="dashboard-mobile-tooltip" multiline place="top" type="dark" effect="solid" />
                <h3 className="quizzes-mobile-title" style={{color: "#364454", fontWeight: "700", fontSize: "20px", marginBottom: "20px"}}>Tests Results</h3>

                <SearchBar
                    className="quizzes-mobile-search"
                    width="80vw"
                    justify={"center"}
                    value={keyword}
                    setValue={e => setKeyword(e.target.value)}
                    placeHolder={"Search by Test or Candidate Name"}
                    style={{
                        borderRadius: '18px',
                        backgroundColor: '#ffffff',
                        border: '1px solid #E0E0E0'
                    }}
                />

                <FlexBox className="quizzes-mobile-tabs mobile-tabs" justify={"space-between"} style={{width: "100%", marginTop: "20px", marginBottom: "15px"}}>
                    {[{name:"All", value:"all"},{name:"Completed", value:"completed"},{name:"Pending", value:"pending"},{name:"Expired", value:"expired"}].map(option => (
                        <button
                            key={option.value}
                            className={`tab-button ${state === option.value ? 'active' : ''}`}
                            onClick={() => {
                                setState(option.value);
                                navigate(`/quiz/list/${option.value === 'all' ? '' : option.value}`);
                            }}
                        >
                            {option.name}
                        </button>
                    ))}
                </FlexBox>

                <div className="quizzes-mobile-cards">
                    {!loader && (!filteredList || filteredList.length == 0) && (
                        <div style={{textAlign: "center", color: "#bababa", padding: "40px"}}>No Tests Found.</div>
                    )}
                    {filteredList && filteredList.map((quiz, i) => (
                        <QuizMobileCard key={i} quiz={quiz} setQuizzes={setQuizzes} setIframeSrc={setIframeSrc} setShowIframe={setShowIframe} />
                    ))}
                </div>

                <div style={{marginTop:"10px", fontSize:"12px", textAlign:"center"}}>{!filteredList ? 0 : filteredList.length} Tests</div>
            </FlexBox>
        </div>
    </PageLayout>)
}

export function QuizRow({quiz, setQuizzes, i, setIframeSrc, setShowIframe, showApprovalDate=false}) {
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const company = useContext(CompanyTeamContext) || {}
    let refreshQuota = company.refresh
    const [privileges, setPrivileges] = useState([])
    const navigate = useNavigate()
    useEffect(()=>{
        if(company && company.privileges){
            setPrivileges(company.privileges || []);
        }
    },[company])

    const deleteQuiz = () => {

        const id = CustomLoadingToast("Deleting...")
        axios.delete(API_URL_PREFIX+"/DeleteQuizOfCandidate.html?quizId=" + quiz.quizId)
            .then(e => {
                let data = e.data;
                if (data && !data.err) {
                    setQuizzes(quizzes => quizzes.filter(e => e.quizId != quiz.quizId))
                    if(refreshQuota) refreshQuota();
                    updateCustomSuccessToast("Deleted", id)
                } else {
                    updateCustomErrorToast(data.info, id)
                }
                setShowConfirmDelete(false)
            })
            .catch(err => {
                setShowConfirmDelete(false)
                updateCustomErrorToast("Error, Please try again", id)
                console.log(err)
            })
    }
    let score = (quiz.quizScore || quiz.quizScore === 0) ? Math.floor(quiz.quizScore) + "%" : "--" ;
    let status=""

    if(quiz.quizScore == -1){
        score = "--";
        // TEST DISQUALIFIED - PRINT SCREEN
        if("1"==(quiz.disqualificationStatus)){
            status = 
            (
                <Tooltip text={"Disqualified: Failure to stay on the test tab."}>
                    <span className="disqualified-frame">
                    <span className="disqualified-text-wrapper">DSQ</span>
                    <img
                        className="disqualified-vector"
                        alt="DisqualifiedIcon"
                        src={DisqualifiedIcon}
                    />
                    </span>
                </Tooltip>
            );
        }
        // TEST DISQUALIFIED - NO GOOGLE
        else if("2"==(quiz.disqualificationStatus)){
            status = 
            (
                <Tooltip text={"Disqualified: Print screen action detected during the test."}>
                    <span className="disqualified-frame">
                    <span className="disqualified-text-wrapper">DSQ</span>
                    <img
                        className="disqualified-vector"
                        alt="DisqualifiedIcon"
                        src={DisqualifiedIcon}
                    />
                    </span>
                </Tooltip>
            );
        }
        // TEST DISQUALIFIED - Screen Share Cancel
        else if("3"==(quiz.disqualificationStatus)){
            status = 
            (
                <Tooltip text={"Disqualified: Screen sharing was stopped during the test."}>
                    <span className="disqualified-frame">
                    <span className="disqualified-text-wrapper">DSQ</span>
                    <img
                        className="disqualified-vector"
                        alt="DisqualifiedIcon"
                        src={DisqualifiedIcon}
                    />
                    </span>
                </Tooltip>
            );
        }
        // TEST DISQUALIFIED - ChatGPT
        else if("4"==(quiz.disqualificationStatus) || "5"==(quiz.disqualificationStatus)){
            status = 
            (
                <Tooltip text={"Disqualified: Unauthorized use of AI tools detected."}>
                    <span className="disqualified-frame">
                    <span className="disqualified-text-wrapper">DSQ</span>
                    <img
                        className="disqualified-vector"
                        alt="DisqualifiedIcon"
                        src={DisqualifiedIcon}
                    />
                    </span>
                </Tooltip>
            );
        }
        else if("6"==(quiz.disqualificationStatus)){
                status = 
                (
                    <Tooltip text={"Disqualified: Unauthorized use of Developer tools detected."}>
                        <span className="disqualified-frame">
                        <span className="disqualified-text-wrapper">DSQ</span>
                        <img
                            className="disqualified-vector"
                            alt="DisqualifiedIcon"
                            src={DisqualifiedIcon}
                        />
                        </span>
                    </Tooltip>
                );
        }
        
        // TEST STOPPED IN THE MIDDLE
        else {
            status = (
                <span className="stopped-button-frame">
                    <span className="stopped-button-text-wrapper">STOPPED</span>
                </span>
            )
        }
        
        
    }
    else{
	if (quiz.quizDate && new Date(quiz.quizDate) > new Date()) {
	  status = <Status label={"SCHEDULED"} status={"scheduled"} />;
	} else {
	  status = <Status status={"pending"} />;
	}

        if(quiz.quizScore || quiz.quizScore == 0){
            if (quiz.quizScore >= 0 &&
                quiz.disqualificationStatus >= 1 && quiz.disqualificationStatus <= 6) {
                // Restored but still disqualified
                const disqualifyReasons = {
                    1: "Failure to stay on the test tab.",
                    2: "Print screen action detected during the test.",
                    3: "Screen sharing was stopped during the test.",
                    4: "Unauthorized use of AI tools detected.",
                    5: "Unauthorized use of AI tools detected.",
                    6: "Unauthorized use of Developer tools detected.",
                };
                score = (
                    <>
                        {Math.floor(quiz.quizScore)}%{" "}
                        <Tooltip text={"Disqualified: " + disqualifyReasons[quiz.disqualificationStatus]}>
                        <img
                            src={DisqualifiedIcon}
                            alt="Disqualified"
                            style={{ width: "16px", height: "16px", marginBottom: "4px", marginLeft: "4px" }}
                        />
                        </Tooltip>
                    </>
                );
            }
            else if (quiz.quizScore >= 0 && quiz.disqualificationStatus > 6) {
                // Restored but disqualified with unknown code
                score = (
                    <>
                        {Math.floor(quiz.quizScore)}% 
                        <span className="stopped-button-frame">
                            <span className="stopped-button-text-wrapper">STOPPED</span>
                        </span>
                    </>
                );
            }
            if((isLiveTestOrQuiz(quiz) && quiz.liveTestResult?.toLowerCase() !== 'passed' && quiz.liveTestResult?.toLowerCase() !== 'failed')) {
                status = 'To be reviewed'
            }
            else if(quiz.quizScore > PASS_THRESHOLD || (isLiveTestOrQuiz(quiz) && quiz.liveTestResult?.toLowerCase() === 'passed')){
                status = <Status status={"passed"} />
            }
            else{
                status = <Status status={"failed"} />
            }
        }
        else if(quiz.isExpired){
            status = <Status label={"EXPIRED"} status={"expired"} />
        }
    }
    let date = new Date(quiz.quizDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    let testStartDate = quiz.quizDate;
    if(quiz.testTime){
        testStartDate = testStartDate - (quiz.testTime*60*1000)
    }
    testStartDate = new Date(testStartDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    return <TableRow>
        <td style={{padding: "15px", textAlign: "center"}}>{+i + 1}</td>
        <td><Link className={"candidate-link"}
               to={APP_URL_PREFIX + "/candidate/" + quiz.candidateKey}>{quiz.candidateName}</Link></td>

        <td>{quiz.predefinedTest ? <span style={{fontWeight:"bold"}}>{getTestName(quiz)}</span> : <Link className={"candidate-link"} to={APP_URL_PREFIX+"/test/"+quiz.testKey}>{getTestName(quiz)}</Link>}</td>
        <td style={{textAlign: "left"}}>{date}</td>
        <td>{isLiveTestOrQuiz(quiz) ? '--' : score}</td>
        <td>{status}</td>
        {showApprovalDate &&  <td>{testStartDate}</td>}
        <td>
            <FlexBox style={{width:"100%", gap: "12px"}} justify={"start"} align={"center"}>
                {quiz.quizScore !=null && (quiz.supportWebcam || quiz.supportSideProctoring) && <ProfilePicturesIcon style={{cursor:"pointer"}} onClick={e=>{
                  setShowIframe(true)
                  setIframeSrc(`${IFRAME_DOMAIN}/ShowProfileImages.html?liteColor=1&quizId=${encodeURIComponent(quiz.quizId)}&candName=${encodeURIComponent((quiz.candidateName))}`)
                }} title={"View Profile Pictures"} cursor="pointer" />}
                {quiz.quizScore >= -1 && !(quiz.quizDate && new Date(quiz.quizDate) > new Date()) && (quiz.supportPrintScreen || quiz.didRiskIdentified) && <ScreenshotsIcon onClick={e=>{
                    setShowIframe(true)
                    setIframeSrc(`${IFRAME_DOMAIN}/PrintScreenReport.htm?liteColor=1&testKey=${encodeURIComponent(quiz.quizId)}&testName=${encodeURIComponent(quiz.testName)}&applicantName=${encodeURIComponent(quiz.candidateName)}`)
                }} style={{cursor:"pointer"}} title={"View Screenshots"}  />}
            </FlexBox>

        </td>

        <td>
            <FlexBox style={{ gap: "12px" }} justify={"start"} align={"center"}>
                <ResendResultsIcon style={{ cursor: "pointer" }} hidden={quiz.quizScore || quiz.quizScore === 0} onClick={() => {
                    resendTest(quiz.quizId, quiz.candidateKey)
                }} title='Resend Test Invitation' cursor="pointer" />
                {privileges.includes(TEST_REVIEW_PRIVILEGE)
                    ?<>
                        <TestReviewButton quiz={quiz} navigate={navigate}/>
                    </>
                    :
                    ""}

                {(quiz.quizScore || quiz.quizScore === 0) && quiz.quizScore !== -1 && !isLiveTestOrQuiz(quiz) &&
                    <img src={testReportIcon} title="Performance Report" style={{cursor:"pointer", width:"24px", height:"24px"}}
                        onClick={() => navigate(
                            `/TestReport?score=${Math.floor(quiz.quizScore)}&testKey=${encodeURIComponent(quiz.quizId || quiz.key)}&externalQuizId=${encodeURIComponent(quiz.quizId || quiz.key)}&companyKey=${encodeURIComponent(company.key || '')}&quizName=${encodeURIComponent(quiz.testName || quiz.name || '')}&candName=${encodeURIComponent(quiz.candidateName || '')}&resultsRaw=${encodeURIComponent(quiz.results || '')}&candidateTime=${encodeURIComponent(quiz.quizTimeTaken || quiz.timeTaken || 0)}&totalTime=${encodeURIComponent(quiz.testTime || quiz.quizTime || 0)}&totalQuestions=${encodeURIComponent(quiz.amountOfQuestions || 0)}&testDate=${encodeURIComponent(new Date(quiz.quizDate).toISOString().split('T')[0])}`
                        )}
                    />
                }

                <DeleteTestIcon style={{ cursor: "pointer" }} hidden={quiz.quizScore || quiz.quizScore === 0} onClick={() => setShowConfirmDelete(true)} title='Delete Test' cursor="pointer" />

                {quiz.quizScore === -1
                    ? <RestoreButton quiz={quiz} company={company} />
                    : <TestChartsButton quiz={quiz} navigate={navigate} />}

            </FlexBox>
        </td>

        {showConfirmDelete
            && <ConfirmModal variant={"danger"} show={showConfirmDelete} setShow={setShowConfirmDelete}
                             callback={deleteQuiz} body={"Are you sure you want to delete " + quiz.candidateName + "'s "+quiz.testName+" quiz?"}
                             title={"Confirm Delete"} yes={"Delete"} no={"Cancel"}
                             fallback={e => setShowConfirmDelete(false)}/>}
    </TableRow>;
}

export const IframeModal = ({setShow, src}) => {
    const [iframeLoading, setIframeLoading] = useState(true);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data === 'iframeContentLoaded') {
                setIframeLoading(false);
            }
        };
        
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    return (<ModalBackground style={{position:"fixed", background:"rgba(0,0,0,.3"}}>
        <FlexBox style={{width:"max-content", height:"max-content", position:"relative"}}>
            <X onClick={e=>setShow(false)} size={"35px"} style={{position:"absolute", top:-35, right:-5, cursor:"pointer", color:"white"}}></X>
            <iframe style={{border:"1px solid #ccc", borderRadius:"14px"}} className={"hard-shadow iframe-responsive"} src={src} />
        </FlexBox>
    </ModalBackground>)
}

export const TestReviewButton = ({quiz, navigate}) =>{
    return                 <TestResultsIcon hidden={(!quiz.quizScore && quiz.quizScore !== 0) || quiz.quizScore == -1} onClick={()=>navigate(
        "/TestReview/"+encodeURIComponent(quiz.quizId || quiz.key)
    )} title='Test Review' cursor="pointer" />
}

export const TestChartsButton = ({quiz, navigate}) =>{

    let timeTaken = quiz.quizTimeTaken
    if(timeTaken !== 0 && !timeTaken){
        timeTaken = quiz.timeTaken
    }

    let score =  Math.floor(quiz.quizScore || 0);

    return <TestChartsIcon  hidden={(!quiz.quizScore && quiz.quizScore !== 0) || quiz.quizScore == -1 || isLiveTestOrQuiz(quiz) }
                                 onClick={()=>navigate("/charts/"+encodeURIComponent(

        "?results="+quiz.results+"&score="+score+"&cand="+encodeURIComponent(quiz.candidateName)+"&quizName="+encodeURIComponent(quiz.testName || quiz.name)+
        "&candidateTime="+(timeTaken) +"&totalTime="+(quiz.testTime || quiz.quizTime || 0) +"&enhanced=true&CompanyKey=&per=1&testKey="+encodeURIComponent(quiz.quizId || quiz.key)))} title='Test Results' style={{cursor: "pointer"}} />
}

// RestoreButton component to restore a quiz
export const RestoreButton = ({ quiz, company }) => {
    const [restoring, setRestoring] = useState(false);
    const handleRestore = () => {
        setRestoring(true);
        const quizId = quiz?.quizId || quiz?.key;

        axios.post(API_URL_PREFIX+"/RestoreQuizLiteByTK.html", null, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            params: {
                companyId: company?.key || "MOCK_ID",
                companyName: company?.name || "Mock Company",
                testKey: quizId
            }
        })
        .then(res => {
            if (res.data?.result) {
                updateCustomSuccessToast("Restoring test... please wait a few minutes, then refresh the page.");
                
            } else {
                CustomErrorToast(res.data?.info || "Restore failed.");
            }
        })
        .catch(() => {
            CustomErrorToast("Error restoring test. Please try again.");
        })
        .finally(() => {
            setRestoring(false);
        });
    };

    return (
        <RestoreTestIcon onClick={handleRestore} disabled={restoring} title="Restore Test" style={{cursor: "pointer"}} />  
    );
};

// Mobile Card Component
function QuizMobileCard({quiz, setQuizzes, setIframeSrc, setShowIframe}) {
    const [showMenu, setShowMenu] = useState(false);
    const [showHandleBar, setShowHandleBar] = useState(true);
    const [translateY, setTranslateY] = useState(0);
    const [touchStart, setTouchStart] = useState(0);
    const [isScrollingContent, setIsScrollingContent] = useState(false);
    const [privileges, setPrivileges] = useState([]);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const company = useContext(CompanyTeamContext) || {};
    let refreshQuota = company.refresh;
    const navigate = useNavigate();

    useEffect(() => {
        if (company && company.privileges) {
            setPrivileges(company.privileges || []);
        }
    }, [company]);

    const deleteQuiz = () => {
        const id = CustomLoadingToast("Deleting...");
        axios.delete(API_URL_PREFIX + "/DeleteQuizOfCandidate.html?quizId=" + quiz.quizId)
            .then(e => {
                let data = e.data;
                if (data && !data.err) {
                    setQuizzes(quizzes => quizzes.filter(e => e.quizId != quiz.quizId));
                    if (refreshQuota) refreshQuota();
                    updateCustomSuccessToast("Deleted", id);
                } else {
                    updateCustomErrorToast(data.info, id);
                }
                setShowConfirmDelete(false);
            })
            .catch(err => {
                setShowConfirmDelete(false);
                updateCustomErrorToast("Error, Please try again", id);
                console.log(err);
            });
    };

    const handleScroll = (e) => {
        if (e.target.scrollTop > 10) {
            setShowHandleBar(false);
        } else {
            setShowHandleBar(true);
        }
    };

    // Smooth swipe-down to dismiss
    useEffect(() => {
        if (!showMenu) {
            setTranslateY(0);
            return;
        }

        const bottomSheet = document.querySelector('.quiz-menu-bottom-sheet');
        const backdrop = document.querySelector('.quiz-menu-backdrop');
        if (!bottomSheet || !backdrop) return;

        let scrollableElement = null;
        let initialScrollTop = 0;

        const handleTouchStart = (e) => {
            const target = e.target;
            const menuContent = target.closest('.quiz-menu-content');

            if (menuContent) {
                scrollableElement = menuContent;
                initialScrollTop = menuContent.scrollTop;
            } else {
                scrollableElement = null;
            }

            setTouchStart(e.touches[0].clientY);
        };

        const handleTouchMove = (e) => {
            if (touchStart === 0) return;

            const touchCurrent = e.touches[0].clientY;
            const diff = touchCurrent - touchStart;

            // If we're in the scrollable content
            if (scrollableElement) {
                const currentScrollTop = scrollableElement.scrollTop;

                // Only allow swipe-to-dismiss if:
                // 1. Scrolled to top (scrollTop === 0)
                // 2. AND swiping down (diff > 0)
                if (currentScrollTop === 0 && diff > 0) {
                    e.preventDefault();
                    setTranslateY(diff);
                    setIsScrollingContent(false);
                } else {
                    // Let the content scroll normally
                    setIsScrollingContent(true);
                    setTranslateY(0);
                }
            } else {
                // Not in content area, allow swipe-to-dismiss
                if (diff > 0) {
                    e.preventDefault();
                    setTranslateY(diff);
                }
            }
        };

        const handleTouchEnd = () => {
            // If swiped down more than 100px, close the menu
            if (translateY > 100) {
                setShowMenu(false);
            } else {
                // Snap back to position
                setTranslateY(0);
            }
            setTouchStart(0);
            setIsScrollingContent(false);
            scrollableElement = null;
        };

        // Prevent pull-to-refresh on backdrop
        const preventBackdropRefresh = (e) => {
            e.preventDefault();
        };

        bottomSheet.addEventListener('touchstart', handleTouchStart, { passive: true });
        bottomSheet.addEventListener('touchmove', handleTouchMove, { passive: false });
        bottomSheet.addEventListener('touchend', handleTouchEnd, { passive: true });
        backdrop.addEventListener('touchmove', preventBackdropRefresh, { passive: false });

        return () => {
            bottomSheet.removeEventListener('touchstart', handleTouchStart);
            bottomSheet.removeEventListener('touchmove', handleTouchMove);
            bottomSheet.removeEventListener('touchend', handleTouchEnd);
            backdrop.removeEventListener('touchmove', preventBackdropRefresh);
        };
    }, [showMenu, touchStart, translateY]);

    let score;
    let scoreColor = "#28A745"; // Green
    let scoreStatus = null; // For DSQ or STOPPED badge
    let scoreStatusTooltip = null; // Tooltip text for DSQ/STOPPED

    const disqualifyReasons = {
        1: "Disqualified: Failure to stay on the test tab.",
        2: "Disqualified: Print screen action detected during the test.",
        3: "Disqualified: Screen sharing was stopped during the test.",
        4: "Disqualified: Unauthorized use of AI tools detected.",
        5: "Disqualified: Unauthorized use of AI tools detected.",
        6: "Disqualified: Unauthorized use of Developer tools detected.",
    };

    if (quiz.quizScore == -1) {
        // Disqualified or stopped - show "--" with status
        score = "--";
        if (quiz.disqualificationStatus >= 1 && quiz.disqualificationStatus <= 6) {
            scoreStatus = "DSQ";
            scoreStatusTooltip = disqualifyReasons[quiz.disqualificationStatus];
            scoreColor = "#FF3B30"; // Red for disqualified
        } else {
            scoreStatus = "STOPPED";
            scoreColor = "#FF9500"; // Orange for stopped
        }
    } else if (quiz.quizScore >= 0) {
        // Has a valid score
        score = Math.floor(quiz.quizScore) + "%";

        if (quiz.disqualificationStatus >= 1 && quiz.disqualificationStatus <= 6) {
            // Restored but still disqualified
            scoreStatus = "DSQ";
            scoreStatusTooltip = disqualifyReasons[quiz.disqualificationStatus];
            scoreColor = "#FF3B30";
        } else if (quiz.disqualificationStatus > 6) {
            // Restored but stopped
            scoreStatus = "STOPPED";
            scoreColor = "#FF9500";
        } else {
            // Normal score
            if (quiz.quizScore < PASS_THRESHOLD) {
                scoreColor = "#DC3545"; // Red for failed
            }
        }
    } else {
        // No score
        score = "--";
        scoreColor = "#6c757d"; // Gray
    }

    let date = new Date(quiz.quizDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

    return (
        <div className="mobile-test-card quiz-mobile-card">
            <div className="mobile-test-card-top quiz-card-top">
                <div style={{display: "flex", flexDirection: "column", gap: "3vw", flex: 1}}>
                    <div style={{display: "flex", flexDirection: "row", gap: "2vw", alignItems: "center"}}>
                        <span className="mobile-test-card-top-label">Test Name</span>
                        <span className="mobile-test-card-top-value">{getTestName(quiz, 15)}</span>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", gap: "2vw", alignItems: "center"}}>
                        <span className="mobile-test-card-top-label">Assigned to</span>
                        <Link className="mobile-test-card-top-value" to={APP_URL_PREFIX + "/candidate/" + quiz.candidateKey} style={{textDecoration: "none"}}>{quiz.candidateName}</Link>
                    </div>
                </div>
                <button
                    className="quiz-card-menu-button"
                    onClick={() => setShowMenu(!showMenu)}
                >
                    ⋮
                </button>
            </div>
            <div className="mobile-test-card-divider"></div>
            <div className="mobile-test-card-bottom">
                <div
                    className="mobile-test-card-bottom-item"
                    data-tip={scoreStatusTooltip || "Test score (0–100)"}
                >
                    <img src={GradeMobileIcon} alt="Grade" />
                    <span className="mobile-test-card-bottom-value" style={{color: scoreColor}}>{score}</span>
                    {scoreStatus && (
                        <span className="mobile-test-card-status-badge" style={{
                            marginLeft: '2vw',
                            fontSize: '3vw',
                            fontWeight: '600',
                            color: scoreColor,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1vw'
                        }}>
                            {scoreStatus}
                            {scoreStatus === "DSQ" && <img src={DsqMobileIcon} alt="DSQ" style={{width: '3vw', height: '3vw'}} />}
                        </span>
                    )}
                </div>
                <div className="mobile-test-card-bottom-item" style={{marginLeft: 'auto'}} data-tip="Last Modified">
                    <img src={DateMobileIcon} alt="Date" />
                    <span className="mobile-test-card-bottom-value">{date}</span>
                </div>
            </div>

            {showMenu && (
                <>
                    <div className="quiz-menu-backdrop" onClick={() => setShowMenu(false)}></div>
                    <div
                        className="quiz-menu-bottom-sheet"
                        style={{
                            transform: `translateY(${translateY}px)`,
                            transition: translateY === 0 ? 'transform 0.3s ease' : 'none'
                        }}
                    >
                        {showHandleBar && <div className="quiz-menu-handle-bar"></div>}
                        <button className="quiz-menu-close" onClick={() => setShowMenu(false)}>
                            <X size={24} />
                        </button>
                        <div className="quiz-menu-content" onScroll={handleScroll}>
                            {/* Supervised section - matches desktop */}
                            {(quiz.quizScore != null && quiz.supportWebcam || quiz.supportPrintScreen || quiz.didRiskIdentified) && (
                                <div className="quiz-menu-section">
                                    <h4 className="quiz-menu-section-title">Supervised</h4>
                                    {quiz.quizScore != null && quiz.supportWebcam && (
                                        <button className="quiz-menu-item" onClick={() => {
                                            setShowIframe(true);
                                            setIframeSrc(`${IFRAME_DOMAIN}/ShowProfileImages.html?liteColor=1&quizId=${encodeURIComponent(quiz.quizId)}&candName=${encodeURIComponent((quiz.candidateName))}`);
                                            setShowMenu(false);
                                        }}>
                                            <img src={ViewProfilePicturesIcon} alt="View profile pictures" />
                                            <span>View profile pictures</span>
                                        </button>
                                    )}
                                    {quiz.quizScore >= -1 && !(quiz.quizDate && new Date(quiz.quizDate) > new Date()) && (quiz.supportPrintScreen || quiz.didRiskIdentified) && (
                                        <button className="quiz-menu-item" onClick={() => {
                                            setShowIframe(true);
                                            setIframeSrc(`${IFRAME_DOMAIN}/PrintScreenReport.htm?liteColor=1&testKey=${encodeURIComponent(quiz.quizId)}&testName=${encodeURIComponent(quiz.testName)}&applicantName=${encodeURIComponent(quiz.candidateName)}`);
                                            setShowMenu(false);
                                        }}>
                                            <img src={ViewScreenShotsIcon} alt="View screenshots" />
                                            <span>View screenshots</span>
                                        </button>
                                    )}
                                </div>
                            )}

                            {/* Actions section - matches desktop */}
                            <div className="quiz-menu-section">
                                <h4 className="quiz-menu-section-title">Actions</h4>

                                {/* Resend test - only if quiz not completed */}
                                {!(quiz.quizScore || quiz.quizScore === 0) && (
                                    <button className="quiz-menu-item" onClick={() => {
                                        resendTest(quiz.quizId, quiz.candidateKey);
                                        setShowMenu(false);
                                    }}>
                                        <img src={ResendTestIcon} alt="Resend test" />
                                        <span>Resend Test Invitation</span>
                                    </button>
                                )}

                                {/* Test results - only if completed and has TEST_REVIEW_PRIVILEGE */}
                                {privileges.includes(TEST_REVIEW_PRIVILEGE) && (quiz.quizScore || quiz.quizScore === 0) && quiz.quizScore !== -1 && (
                                    <button className="quiz-menu-item" onClick={() => {
                                        navigate("/TestReview/" + encodeURIComponent(quiz.quizId));
                                        setShowMenu(false);
                                    }}>
                                        <img src={TestResultsIconMobile} alt="Test review" />
                                        <span>Test review</span>
                                    </button>
                                )}

                                {/* Test charts - only if completed and not disqualified and not live test */}
                                {(quiz.quizScore || quiz.quizScore === 0) && quiz.quizScore !== -1 && !isLiveTestOrQuiz(quiz) && (
                                    <button className="quiz-menu-item" onClick={() => {
                                        let timeTaken = quiz.quizTimeTaken;
                                        if (timeTaken !== 0 && !timeTaken) {
                                            timeTaken = quiz.timeTaken;
                                        }
                                        let scoreValue = Math.floor(quiz.quizScore || 0);
                                        navigate("/charts/" + encodeURIComponent(
                                            "?results=" + quiz.results + "&score=" + scoreValue + "&cand=" + encodeURIComponent(quiz.candidateName) +
                                            "&quizName=" + encodeURIComponent(quiz.testName || quiz.name) +
                                            "&candidateTime=" + (timeTaken) + "&totalTime=" + (quiz.testTime || quiz.quizTime || 0) + "&enhanced=true&CompanyKey=&per=1&testKey=" + encodeURIComponent(quiz.quizId)
                                        ));
                                        setShowMenu(false);
                                    }}>
                                        <img src={TestChartsIconMobile} alt="Test results" />
                                        <span>Test results</span>
                                    </button>
                                )}

                                {/* Restore test - only if disqualified */}
                                {quiz.quizScore === -1 && (
                                    <button className="quiz-menu-item" onClick={() => {
                                        // Restore logic
                                        const quizId = quiz.quizId;
                                        axios.post(API_URL_PREFIX + "/RestoreQuizLiteByTK.html", null, {
                                            headers: {
                                                "Content-Type": "application/x-www-form-urlencoded"
                                            },
                                            params: {
                                                companyId: company?.key || "MOCK_ID",
                                                companyName: company?.name || "Mock Company",
                                                testKey: quizId
                                            }
                                        })
                                        .then(res => {
                                            if (res.data?.result) {
                                                updateCustomSuccessToast("Restoring test... please wait a few minutes, then refresh the page.");
                                            } else {
                                                CustomErrorToast(res.data?.info || "Restore failed.");
                                            }
                                        })
                                        .catch(() => {
                                            CustomErrorToast("Error restoring test. Please try again.");
                                        });
                                        setShowMenu(false);
                                    }}>
                                        <img src={RestoreTestIconMobile} alt="Restore test" />
                                        <span>Restore test</span>
                                    </button>
                                )}

                                {/* Delete test - only if quiz not completed */}
                                {!(quiz.quizScore || quiz.quizScore === 0) && (
                                    <>
                                        <div className="quiz-menu-divider"></div>
                                        <button className="quiz-menu-item" onClick={() => {
                                            setShowConfirmDelete(true);
                                            setShowMenu(false);
                                        }}>
                                            <img src={DeleteTestIconMobile} alt="Delete test" />
                                            <span>Delete test</span>
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {showConfirmDelete && (
                <ConfirmModal
                    variant={"danger"}
                    show={showConfirmDelete}
                    setShow={setShowConfirmDelete}
                    callback={deleteQuiz}
                    body={"Are you sure you want to delete " + quiz.testName + " test ?"}
                    title={""}
                    yes={"Delete"}
                    no={"Cancel"}
                    fallback={e => setShowConfirmDelete(false)}
                    mobileIcon={ConfirmModalDeleteIcon}
                />
            )}
        </div>
    );
}


export default QuizzesList